import React, { useRef, useState } from "react";
import Svg from "../../Components/Svg";
import QuickSearchContainer from "../../Containers/QuickSearch.container";
import { useSelector } from "react-redux";

/**
 * @typedef {Object} IconAndUrl
 * @property {string} iconId - The ID of the icon.
 * @property {string} iconUrl - The URL of the icon image.
 * @property {Object} url - The URL object associated with this icon.
 */

/**
 * @param {MutableRefObject} menuRef
 * @returns {JSX.Element}
 */
const MobileNavigation = ({
    menuRef
}) => {
    const mobileNavigation = useSelector(state => state.navigation.mobileNavigation);
    const validNavItems = mobileNavigation.filter(n => typeof n.url !== 'undefined' && n.url !== null && typeof n.url.href !== 'undefined');

    let burgerBtn = useRef();
    const [menuOpen, setMenuOpen] = useState(false);

    function toggleMenu() {
        if (menuRef.current) {
            menuRef.current.classList.toggle('navbar__menu--show')
        }

        if (burgerBtn.current) {
            burgerBtn.current.classList.toggle('navbar__icon--menu')
            burgerBtn.current.classList.toggle('navbar__icon--close')
        }

        setMenuOpen(!menuOpen);
    }

    return (
        <div className="header__navigation-mobile d-flex large:d-none flow-row-nowrap">
            {validNavItems.map((item, index) =>
                <a className="navbar__item--icon" 
                    key={'mobile-nav-' + index}
                    href={item.url.href}
                    title={item.url.text}
                >
                    {item.iconUrl !== '' ?
                        <img src={item.iconUrl} alt={item.url.text} /> :
                        <Svg icon={item.iconId} label={item.url.text} />}
                </a>
            )}

            <QuickSearchContainer className="navbar__item--icon" isMuurikka={false} />

            <div className="navbar__item--icon"
                ref={burgerBtn}
                onClick={toggleMenu}
            >
                <Svg icon={!menuOpen ? 'hamburger-menu-2' : 'close'} />
            </div>
        </div>
    );
}

export default MobileNavigation;
